import { api } from "api/api";
import { SimulateFinanceData } from "pages/SimulatorFinance";

export interface ResultResponse {
  minimumGrossIncomeRequired: string;
  firstPayment: string;
  lastPayment: string;
  paymentTerm: string;
  interestRate: string;
}

export const simulatorFinanceService = {
  simulateSac(params: SimulateFinanceData) {
    const response = api.post("/sac", params);
    return response;
  },

  simulatePrice(params: SimulateFinanceData) {
    const response = api.post("/price", params);
    return response;
  },
};
